<template>
	<!-- 证书查询结果 -->
	<div class="wid-100">
		<div class="" style="">
			<div class="box-shadow pad-16 mb-16">
				<!-- <div class="pad-1 mb-16"> -->
				<div class="flex-1 jus-bet mb-32">
					<div class="flex-1 jus-bet">
						<div class="left-icon"></div>
						<p class="record-1">证书查询</p>
					</div>
				</div>
				<div class="flex-1 zhengshu jus-bet">
					<div class="flex-1">
						<p>证书编号</p>
						<el-input v-model="form.no" placeholder="请输入证书编号" disabled></el-input>
					</div>
					<div class="flex-1">
						<p>姓名</p>
						<el-input v-model="form.name" placeholder="请输入姓名" disabled></el-input>
					</div>
				</div>
			</div>
			<div class="box-shadow pad-16">
				<div class="flex-1 jus-bet mb-32">
					<div class="flex-1 jus-bet">
						<div class="left-icon"></div>
						<p class="record-1">查询结果</p>
					</div>
				</div>
				<div class="mb-32 flex-1 jus-bet">
					<div></div>
					<img :src="form.img" alt="" style="width: 50%;height: auto;">
					<div></div>
				</div>
				<div class="flex-1 jus-bet mb-16">
					<div></div>
					<el-button type="primary" @click="downLoad(form.img)">下载</el-button>
					<div></div>
				</div>
			</div>

		</div>
		<router-view></router-view>
	</div>
</template>

<script>
	import {
		getBase64
	} from '@/api/personal/api.js';
	export default {
		components: {},
		data() {
			return {
				activeName: '',
				form: {
					no: '',
					name: '',
					img: ''
				}
			}

		},
		mounted() {
			this.form = this.$route.params;
		},
		methods: {
			// 下载
			downLoad(content) {
				let name = new Date().getTime();
				let imageUrl = content;
				getBase64({
					name: name,
					url: imageUrl,
				}).then(res => {
					if (res.code == 0) {
						//  // 以时间来命名图片，防止重名
						this.downloadIamge(res.data, `${name}`);
					}
				})
			},
			// 方法
			downloadIamge(imgsrc, name) {
				var image = new Image();
				image.setAttribute("crossOrigin", "anonymous");
				image.onload = function() {
					var canvas = document.createElement("canvas");
					canvas.width = image.width;
					canvas.height = image.height;
					var context = canvas.getContext("2d");
					context.drawImage(image, 0, 0, image.width, image.height);
					var url = canvas.toDataURL("image/png");

					var a = document.createElement("a");
					var event = new MouseEvent("click");
					a.download = name || "photo";
					a.href = url;
					a.dispatchEvent(event);
				};
				image.src = imgsrc;
			},
		}
	}
</script>

<style>

</style>
<style scoped>
	.box-shadow {
		box-shadow: 2px 2px 8px 0px rgba(195, 219, 255, 0.25);
		border-radius: 8px 8px 8px 8px;
	}

	.pad-16 {
		padding: 16px;
	}

	.flex-1 {
		display: flex;
		align-items: center;
	}

	.jus-bet {
		justify-content: space-between;
	}

	.left-icon {
		width: 6px;
		height: 20px;
		background: #3377FF;
		border-radius: 18px;
		margin-right: 10px;
	}

	.record {
		font-size: 14px;
		color: #333333;
		line-height: 21px;
		margin-right: 8px;
	}

	.record-1 {
		font-size: 20px;
		color: #222222;
	}

	.mb-32 {
		margin-bottom: 32px;
	}

	.mb-16 {
		margin-bottom: 16px;
	}

	.el-button--primary {
		background-color: #3377FF;
		color: #ffffff;
		border-radius: 4px;
		font-size: 16px;
		width: 15%;
	}

	.zhengshu {
		padding-left: 10px;
		white-space: nowrap;
		width: 100%;
	}

	.zhengshu .flex-1 {
		width: 40%;
	}

	.zhengshu p {
		color: #222222;
		font-size: 14px;
		padding-right: 16px;
	}

	.zhengshu .el-input {
		width: 85%;
	}

	/deep/.zhengshu .el-input__inner::placeholder {
		color: #999999;
		font-size: 14px;
	}
</style>